import React from "react";
import LegalLayout from "./LegalLayout";

const CLAUSE_CONEXO_ROLE = (
    <div className="bg-primary/5 border border-primary/20 p-6 rounded-2xl mb-8">
        <h3 className="text-primary font-black uppercase tracking-widest text-xs mb-3">Aviso Importante</h3>
        <p className="text-sm font-medium italic text-primary/80 leading-relaxed m-0">
            Conexo POS es una plataforma tecnológica que conecta restaurantes con repartidores independientes.
            Conexo no actúa como empresa de reparto ni empleador de riders. Los restaurantes son los únicos responsables
            de la relación contractual y legal con sus repartidores, quienes operan como prestadores de servicios independientes.
        </p>
    </div>
);

export const TerminosDeUso = () => (
    <LegalLayout title="Términos de Uso">
        {CLAUSE_CONEXO_ROLE}
        <p>Bienvenido a Conexo POS. Al utilizar nuestra plataforma, aceptas cumplir con los siguientes términos y condiciones de servicio.</p>

        <h2>1. Naturaleza del Servicio</h2>
        <p>Conexo POS proporciona herramientas de software (SaaS) para la gestión integral de restaurantes, incluyendo TPV, pedidos QR y módulos de logística de última milla.</p>
        <p>Nuestra función es estrictamente tecnológica. No intervenimos en la preparación de alimentos ni en la ejecución física de los repartos.</p>

        <h2>2. Responsabilidades del Usuario</h2>
        <p>El Restaurante es responsable de la exactitud de la información proporcionada a través de la plataforma, así como del cumplimiento de sus obligaciones fiscales y sanitarias vigentes.</p>

        <h2>3. Tarifas y Pagos</h2>
        <p>Los servicios se facturan según el plan suscrito. La falta de pago resultará en la suspensión temporal o definitiva del acceso a la plataforma.</p>
    </LegalLayout>
);

export const PoliticaRiders = () => (
    <LegalLayout title="Política para Riders">
        {CLAUSE_CONEXO_ROLE}
        <p>Esta política regula el uso de la aplicación PWA para repartidores integrados en la red de Conexo POS.</p>

        <h2>1. Independencia Laboral</h2>
        <p>El Rider reconoce satisfactoriamente que utiliza Conexo POS únicamente como una herramienta tecnológica para recibir solicitudes de entrega. No existe, ni se pretende crear, relación laboral, de agencia o subordinación entre el Rider y Conexo POS.</p>
        <p>El Rider es un profesional independiente que gestiona sus propios medios y horarios.</p>

        <h2>2. Normas de Comportamiento</h2>
        <p>Los repartidores deben mantener estándares profesionales de puntualidad y cuidado en el transporte de los productos. El incumplimiento de estas normas puede resultar en la baja de la plataforma por parte de los restaurantes asociados.</p>

        <h2>3. Seguridad Vial</h2>
        <p>El Rider es el único responsable de contar con los permisos, seguros y equipamiento necesario para operar su vehículo de acuerdo con la legislación local.</p>
    </LegalLayout>
);

export const PoliticaRestaurantes = () => (
    <LegalLayout title="Política para Restaurantes">
        {CLAUSE_CONEXO_ROLE}
        <h2>1. Gestión de Reparto y Responsabilidad</h2>
        <p>El Restaurante es el único responsable de la contratación, supervisión y pago de sus repartidores. Conexo POS actúa exclusivamente como facilitador tecnológico (marketplace de logística).</p>
        <p>El Restaurante asume toda la responsabilidad legal derivada de la relación con sus repartidores.</p>

        <h2>2. Comisiones de Plataforma</h2>
        <p>Conexo POS cobra una comisión fija de 0.50€ por cada pedido entregado exitosamente a través de la red de delivery. Esta comisión cubre el mantenimiento de la tecnología de tracking y despacho.</p>

        <h2>3. Calidad del Servicio</h2>
        <p>El Restaurante se compromete a preparar los pedidos en los tiempos indicados para no perjudicar la eficiencia de los repartidores y la experiencia del cliente final.</p>
    </LegalLayout>
);

export const PoliticaPrivacidad = () => (
    <LegalLayout title="Política de Privacidad">
        <p>En Conexo POS, nos tomamos muy en serio la seguridad de tus datos y los de tus clientes.</p>

        <h2>1. Datos que Recopilamos</h2>
        <p>Información del restaurante, datos de contacto del personal, ubicación GPS del Rider durante un pedido activo y datos de ventas para informes analíticos.</p>

        <h2>2. Uso de la Información</h2>
        <p>Los datos se utilizan exclusivamente para la operatividad del sistema POS y la logística de entrega. No vendemos datos a terceros.</p>

        <h2>3. Tus Derechos</h2>
        <p>Puedes ejercer tus derechos de acceso, rectificación, cancelación y oposición enviando un correo a soporte@conexopos.com.</p>
    </LegalLayout>
);

export const PoliticaCookies = () => (
    <LegalLayout title="Política de Cookies">
        <p>Utilizamos cookies técnicas y analíticas para que el sistema funcione correctamente y para entender cómo se usa nuestra plataforma.</p>
        <p>Las cookies esenciales son necesarias para mantener tu sesión activa en el TPV y en el Dashboard. Sin ellas, el sistema no podrá operar.</p>
    </LegalLayout>
);

export const SLAServicio = () => (
    <LegalLayout title="SLA de Servicio">
        <p>Garantizamos un tiempo de actividad (uptime) del 99.9% para nuestros servidores críticos de TPV y Recepción de Pedidos.</p>

        <h2>1. Ventanas de Mantenimiento</h2>
        <p>Cualquier mantenimiento programado será comunicado con 48 horas de antelación y se realizará siempre en horarios de baja actividad hostelería (madrugada).</p>

        <h2>2. Soporte Técnico</h2>
        <p>Ofrecemos soporte prioritario vía WhatsApp para incidencias críticas que impidan la operativa del restaurante.</p>
    </LegalLayout>
);
